import React from "react";
import "../../assets/style/USWDSTable.css"; // You can style checkboxes or loading here

const USWDSTable = ({
  rows,
  columns,
  isLoading,
  onRowClick,
  onSelectionModelChange,
  checkboxSelection = false,
}) => {
  const handleCheckboxChange = (event, rowId) => {
    if (onSelectionModelChange) {
      const isChecked = event.target.checked;
      onSelectionModelChange((prev) => {
        if (isChecked) return [...prev, rowId];
        return prev.filter((id) => id !== rowId);
      });
    }
  };

  return (
    <div className="grid-container">
      <div className="grid-row">
        <div className="grid-col">
          {isLoading ? (
            <div className="usa-alert usa-alert--info">
              <div className="usa-alert__body">
                <p className="usa-alert__text">Loading data, please wait…</p>
              </div>
            </div>
          ) : (
            <table className="usa-table usa-table--borderless width-full">
              <thead>
                <tr>
                  {checkboxSelection && <th>Select</th>}
                  {columns.map((col) => (
                    <th key={col.field}>{col.headerName}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map((row) => (
                    <tr
                      key={row.id}
                      className={
                        row.tax_head_email_sent !== 0 ? "usa-disabled-row" : ""
                      }
                      onClick={() =>
                        row.tax_head_email_sent === 0 && onRowClick(row)
                      }
                      style={{
                        cursor:
                          row.tax_head_email_sent === 0
                            ? "pointer"
                            : "not-allowed",
                      }}
                    >
                      {checkboxSelection && (
                        <td>
                          <input
                            type="checkbox"
                            disabled={row.tax_head_email_sent !== 0}
                            onChange={(e) => handleCheckboxChange(e, row.id)}
                          />
                        </td>
                      )}
                      {columns.map((col) => (
                        <td key={col.field}>{row[col.field]}</td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columns.length + (checkboxSelection ? 1 : 0)}>
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default USWDSTable;
